'use strict';

angular.module('amexReconciliationApp')
  .component('sessionTimeoutWarningModal', {
    templateUrl: 'scripts/views/components/session-timeout-warning-modal.html',
    bindings: {
      dismissModalCallback: '&'
    },
    controller: function (SessionTimeoutService, AnalyticsService) {
      var self = this;

      self.dismissModal = function() {
        AnalyticsService.logExtendSession();
        self.dismissModalCallback();
      };

      self.timeRemaining = function timeRemaining() {
        return moment(SessionTimeoutService.getRemainingTime() / 1000, 's').format('s');
      };
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/sessionTimeoutWarningModal.js
// module id = 479
// module chunks = 0